import ChanceIcon from '@material-ui/icons/Star';
import ChanceReportsList from './components/ChanceReportsList';
import { APP_TYPES, CAUCASUS_TYPES, roles } from '../../../config/constants';

const appType = process.env.REACT_APP_APP_TYPE;

const options = {
  appTypes: [APP_TYPES.ALL],
  allowedRoles: CAUCASUS_TYPES.includes(appType) ? [roles.ADMIN, roles.JTI_TEAM] : [roles.ADMIN],
  label: 'Chance',
  subMenuName: 'reports',
};

export default {
  list: ChanceReportsList,
  icon: ChanceIcon,
  name: 'admin/reports/lotteries',
  options,
};
